"use strict";

import angular from "angular";

angular.module("nucont.publicVariablesIndicatorsCharts", ["nucont.shared"]);
require("./public-variables-indicators-chart.routes");
